import { MatchStatus } from "@/types";
import Badge from "@/components/atoms/Badge";
import Text from "@/components/atoms/Text";
import React from "react";
import { useTranslation } from "react-i18next";

interface MatchStatusLabelProps {
  status: MatchStatus;
}

export const MatchStatusLabel: React.FC<MatchStatusLabelProps> = ({ status }) => {
  const { t } = useTranslation();
  const translationKey = "enumerables:matchStatus." + status;
  const text = t(translationKey);

  switch (status) {
    case "PENDING":
    case "PENDING_CUSTOMER":
    case "UNMATCHED":
      return (
        <Badge color={"warning"} radius={"xs"}>
          {text}
        </Badge>
      );
    case "MATCHED_AUTO":
    case "MATCHED_MANUAL":
      return (
        <Badge color={"completed"} radius={"xs"}>
          {text}
        </Badge>
      );
    case "ERROR":
      return (
        <Badge color={"error"} radius={"xs"}>
          {text}
        </Badge>
      );
    default:
      return <Text>{text || status}</Text>;
  }
};

export default MatchStatusLabel;
